import { Flex, Divider } from "@chakra-ui/react";
import CardDefault from "components/Cards/CardDefault";
import ActionsKebabMenu from "ui/components/ActionsKebabMenu";
import { MdDelete, MdEdit, MdPreview } from "react-icons/md";
import ContentRight from "./components/ContentRight";
import DescricaoCotacao from "./components/DescricaoCotacao";
import { OrcamentoCotacaoFornecedor } from "features/orcamento/typings";
import { AiOutlineCheck } from "react-icons/ai";

interface ItemCotacaoProps {
  item: OrcamentoCotacaoFornecedor;
  indexItem: number | undefined;
  onRowClick?: (id: string) => void;
  onEdit: (id: string) => void;
  handleDelete: (ids: string) => Promise<void>;
  onView: (id: string) => void;
  onApprove?: (id: string) => void;
}

export default function ItemCotacao({
  item,
  indexItem,
  onEdit,
  handleDelete,
  onRowClick,
  onView,
  onApprove,
}: ItemCotacaoProps) {
  return (
    <CardDefault mb={6} px={3} py={0} cursor="pointer">
      <Flex>
        <Flex flexDirection="column" flex={4} py={4}>
          <DescricaoCotacao item={item} />
        </Flex>
        <Flex mx={4}>
          <Divider orientation="vertical" />
        </Flex>
        <Flex flex={1.5} py={6}>
          <ContentRight item={item} />
        </Flex>
        <Flex h="fit-content" py={4}>
          <ActionsKebabMenu
            indexItem={indexItem}
            item={item}
            actions={[
              {
                title: "Ver detalhes",
                icon: () => <MdPreview />,
                onClick: (v) => {
                  onView(v.id);
                },
              },
              {
                title: "Editar",
                icon: () => <MdEdit />,
                onClick: (v) => onEdit(v.id),
              },
              {
                title: "Aprovar itens",
                icon: () => <AiOutlineCheck />,
                onClick: (v) => onApprove?.(v.id),
                shouldRender: (item) => !!item.items?.length,
              },
              {
                title: "Excluir",
                icon: () => <MdDelete />,
                onClick: (v) => handleDelete(v.id),
              },
            ]}
          />
        </Flex>
      </Flex>
    </CardDefault>
  );
}
